import { authFetch } from '@/services/api.service';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3003/api';

export interface ApiSessionResponse {
  success: boolean;
  data: ApiSession | null;
  message?: string;
}

export interface ApiSession {
  id: number;
  date: string;
  shift: string;
  status: 'draft' | 'completed';
  safetyFactor: number;
  createdBy: number | null;
  completedBy: number | null;
  completedAt: string | null;
  createdAt: string;
  updatedAt: string;
  rows: ApiRow[];
}

export interface ApiRow {
  id: number;
  sessionId: number;
  locationId: number;
  location: {
    id: number;
    nombre: string;
  };
  // morning/afternoon fields
  parameterPreviousDay: number;
  initialStock: number;
  waste: number;
  previousDayDispatch: number;
  fixedDispatch: number;
  calculatedDispatch: number;
  // afternoon-transfer fields
  afternoonSaleHistoric: number;
  afternoonSalePreviousDay: number;
  previousWeekAfternoonSale: number;
  morningTodaySale: number;
  todayAfternoonSale: number;
  saleUntilNow: number;
  currentStock: number;
  suggested: number;
  // afternoon-order fields
  historicAvgSaleTotal: number;
  totalSalePreviousDay: number;
  totalSalePreviousWeek: number;
  quantityToRequest: number;
  requestToBakery: number;
  orderToBakery: number;
}

export const fetchSession = async (date: string, shift: string): Promise<ApiSession | null> => {
  const response = await authFetch(`${API_BASE_URL}/bread-transfers?date=${date}&shift=${shift}`);
  if (!response.ok) throw new Error('Error obteniendo sesión');
  const result: ApiSessionResponse = await response.json();
  return result.data;
};

export const createSessionApi = async (date: string, shift: string, safetyFactor?: number): Promise<ApiSession> => {
  const response = await authFetch(`${API_BASE_URL}/bread-transfers`, {
    method: 'POST',
    body: JSON.stringify({ date, shift, safetyFactor })
  });
  if (!response.ok) throw new Error('Error creando sesión');
  const result: ApiSessionResponse = await response.json();
  if (!result.data) throw new Error('No se recibió sesión');
  return result.data;
};

export const updateRowApi = async (sessionId: number, rowId: number, field: string, value: number): Promise<void> => {
  const response = await authFetch(`${API_BASE_URL}/bread-transfers/${sessionId}/rows/${rowId}`, {
    method: 'PUT',
    body: JSON.stringify({ field, value })
  });
  if (!response.ok) throw new Error('Error actualizando fila');
};

export const completeSessionApi = async (sessionId: number): Promise<void> => {
  const response = await authFetch(`${API_BASE_URL}/bread-transfers/${sessionId}/complete`, {
    method: 'PUT'
  });
  if (!response.ok) throw new Error('Error completando sesión');
};

export const resetSessionApi = async (sessionId: number): Promise<void> => {
  const response = await authFetch(`${API_BASE_URL}/bread-transfers/${sessionId}/reset`, {
    method: 'PUT'
  });
  if (!response.ok) throw new Error('Error reiniciando sesión');
};

export const updateSafetyFactorApi = async (sessionId: number, safetyFactor: number): Promise<void> => {
  const response = await authFetch(`${API_BASE_URL}/bread-transfers/${sessionId}/safety-factor`, {
    method: 'PUT',
    body: JSON.stringify({ safetyFactor })
  });
  if (!response.ok) throw new Error('Error actualizando factor de seguridad');
};
